
    <div class="appBottomMenu">
        <a (click)="openPage('/home')" class="item"
            [class]="(routerName=='/home' || routerName=='/home/'+deviceId) ? 'active':''">
            <div class="col">
                <ion-icon name="{{routerName=='/home' || routerName=='/home/'+deviceId ? 'home' : 'home-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'homeTap' | translate}}</h5>
            </div>
    
        </a>
        <a (click)="openPage('/wallet')" class="item" [class]="routerName=='/wallet'? 'active':''"
            *ngIf="isUserLoggedIn">
            <div class="col">
                <ion-icon name="{{routerName=='/wallet' ? 'wallet' : 'wallet-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'walletTap' | translate}}</h5>
            </div>
        </a>
    
        <!-- <a (click)="openPage('/promotion/list')" class="item" [class]="routerName=='/promotion/list'? 'active':''"
            *ngIf="isUserLoggedIn">
            <div class="col">
                <ion-icon name="{{routerName=='/promotion/list' ? 'megaphone' : 'megaphone-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'promotionTap' | translate}}</h5>
            </div>
        </a> -->
       
        <a (click)="openChat()" class="item"
            [class]="routerName=='/service/service-phone'? 'active':''"  
            *ngIf="isUserLoggedIn && useChat">
            <div class="col">
                <span style="position: relative; display: inline-block;">
                    <ion-icon name="chatbubbles-outline"></ion-icon>
                    <div id="chat-unread-widget"  *ngIf="unreadCount >0"
                         style="position: absolute; top: -8px; right: -12px; min-width: 22px; height: 22px; padding: 0 6px; background: #ee5a6f; color: #fff; border-radius: 50%; font-size: 12px; line-height: 22px; text-align: center; font-weight: 700; box-sizing: border-box;"
                         [class.has-mention]="hasMention">
                        {{ unreadCount }}
                    </div>
                </span>
                <h5 class="active-title">{{ 'chatTap' | translate}}</h5>
            </div>
        </a>
        <a (click)="openPage('/service/service-phone')" class="item"
            [class]="routerName=='/service/service-phone'? 'active':''">
            <div class="col">
                <ion-icon name="{{routerName=='/service/service-phone'  ? 'call' : 'call-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'serviceTap' | translate}}</h5>
            </div>
        </a>

        <a (click)="openPage('/profile/me-page')" class="item" [class]="routerName=='/profile/me-page'? 'active':''">
            <div class="col">
                <ion-icon name="{{routerName=='/profile/me-page'  ? 'person' : 'person-outline'}}"></ion-icon>
                <h5 class="active-title">{{ 'meTap' | translate}}</h5>
            </div>
        </a>
    
    </div>
